import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEO from '@/components/feature/SEO';
import { aboutStats } from '@/mocks/articles';

const aboutSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于911爆料网',
  description: '911爆料网 — 吃瓜黑料第一站，全网最快爆料平台。品牌介绍、品牌声誉与联系方式。',
  url: 'http://baoliaowang.cn/about',
  mainEntity: {
    '@type': 'Organization',
    name: '911爆料网',
    description: '911爆料网最新地址发布页，专为吃瓜群众准备的实时黑料追踪站。网红翻车、塌房现场、明星私下猛料每日更新，不遗漏任何一个网络大瓜。',
    url: 'http://baoliaowang.cn/',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'hello@baoliaowang.cn',
    },
  },
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: '首页', item: 'http://baoliaowang.cn/' },
    { '@type': 'ListItem', position: 2, name: '关于我们' },
  ],
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '911爆料网是什么？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '911爆料网是国内领先的娱乐爆料平台，专注于网红翻车、明星私料、综艺黑幕等实时追踪报道，被誉为"吃瓜黑料第一站"。',
      },
    },
    {
      '@type': 'Question',
      name: '如何向911爆料网投稿？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以将爆料内容发送至投稿邮箱 hello@baoliaowang.cn，我们的编辑团队会在24小时内审核并回复。所有爆料人的信息将严格保密。',
      },
    },
    {
      '@type': 'Question',
      name: '911爆料网的信息来源可靠吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '911爆料网采用多方交叉验证机制，所有爆料均经过至少两个独立信源的核实才会发布。我们坚持"不传谣、不信谣"的原则，致力于为吃瓜群众提供真实可靠的娱乐资讯。',
      },
    },
  ],
};

export default function About() {
  return (
    <>
      <SEO
        title="关于我们"
        description="911爆料网 — 吃瓜黑料第一站，全网最快爆料平台。品牌介绍、品牌声誉与联系方式。了解911爆料网的故事。"
        keywords="911爆料网,关于我们,品牌介绍,爆料平台,吃瓜第一站,联系方式"
        canonicalUrl="http://baoliaowang.cn/about"
        schema={{ ...aboutSchema, ...breadcrumbSchema, ...faqSchema }}
      />
      <Navbar />
      <main>
        <section className="bg-background-50 pt-24 pb-16 md:pb-20">
          <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
            <h1 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 mt-8 leading-tight">
              关于
              <br />
              <span className="text-primary-500">911爆料网</span>
              <br />
              吃瓜第一站
            </h1>
            <p className="mt-5 text-foreground-500 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
              全网最快的娱乐爆料平台，致力于为吃瓜群众提供第一手的新鲜大瓜
            </p>
          </div>
        </section>

        <section className="bg-background-50 pb-16 md:pb-20">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="relative w-full max-w-3xl mx-auto h-[280px] md:h-[360px]">
              {aboutStats.map((stat, i) => {
                const positions = [
                  'left-[5%] top-4 z-10 -rotate-3',
                  'left-1/2 -translate-x-1/2 top-0 z-20',
                  'right-[5%] top-4 z-10 rotate-3',
                ];
                const sizes = [
                  'w-[180px] md:w-[240px] h-[200px] md:h-[260px]',
                  'w-[200px] md:w-[280px] h-[240px] md:h-[320px]',
                  'w-[180px] md:w-[240px] h-[200px] md:h-[260px]',
                ];
                return (
                  <div key={stat.label} className={`absolute ${positions[i]} ${sizes[i]} bg-background-100 rounded-xl flex flex-col items-center justify-center p-4 md:p-6 transition-all duration-300 hover:translate-y-[-4px]`}>
                    <span className="font-heading text-3xl md:text-5xl font-black text-primary-500">
                      {stat.value}
                    </span>
                    <span className="mt-2 font-heading font-bold text-foreground-900 text-sm md:text-base">
                      {stat.label}
                    </span>
                    <p className="mt-1.5 text-foreground-500 text-xs text-center leading-relaxed">
                      {stat.description}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <section className="bg-gradient-to-br from-primary-900 via-primary-800 to-primary-950 py-16 md:py-20">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row items-start gap-8 md:gap-12">
              <div className="lg:w-[60%]">
                <span className="inline-block px-3 py-1 bg-accent-100/20 text-accent-300 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
                  / 品牌
                </span>
                <h2 className="font-heading text-2xl md:text-4xl font-black text-background-50 leading-tight">
                  911爆料网
                  <br />
                  吃瓜黑料第一站
                </h2>
                <div className="mt-6 text-background-50/80 text-sm md:text-base leading-relaxed space-y-4">
                  <p className="indent-6">
                    911爆料网成立于2024年，是国内领先的娱乐爆料与吃瓜追踪平台。我们拥有一支专业的爆料记者团队，全天候追踪娱乐圈、网红圈的最新动态，为吃瓜群众提供真实、快速、全面的第一手资讯。
                  </p>
                  <p className="indent-6">
                    我们秉承"不传谣、不信谣"的宗旨，所有爆料均经过严格的多方交叉验证。在行业内，911爆料网以87%的全网首发率和日均100+条的更新量遥遥领先，覆盖超过500位娱乐圈及网红圈核心人物。
                  </p>
                  <p className="indent-6">
                    我们的使命是为每一位吃瓜群众提供最新鲜、最劲爆的网络大瓜。无论是网红翻车塌房现场、明星私下猛料，还是综艺节目的幕后黑幕 — 只要有大瓜的地方，就有911爆料网。
                  </p>
                </div>
              </div>
              <div className="lg:w-[40%]">
                <div className="w-full aspect-square rounded-xl overflow-hidden bg-background-50/10 flex items-center justify-center">
                  <span className="font-heading text-6xl md:text-8xl font-black text-background-50/20">
                    911
                  </span>
                </div>
                <div className="mt-6 text-center">
                  <span className="font-heading text-5xl md:text-6xl font-black text-background-50">
                    NO.1
                  </span>
                  <p className="mt-2 text-background-50/60 text-sm">吃瓜第一站</p>
                  <p className="mt-1 text-background-50/40 text-xs leading-relaxed">
                    自创立以来始终站在爆料最前沿
                    <br />
                    全网首发率遥遥领先
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="relative min-h-[420px] md:min-h-[500px] flex flex-col items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20night%20cityscape%20with%20glowing%20skyscrapers%2C%20dramatic%20golden%20and%20amber%20light%20streaks%2C%20cinematic%20mood%2C%20luxurious%20dark%20aesthetic%2C%20modern%20urban%20atmosphere%2C%20high%20contrast%2C%20editorial%20photography&width=1920&height=1000&seq=cta-bg-about&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

          <div className="relative z-10 text-center px-4 max-w-2xl mx-auto">
            <h2 className="font-heading text-3xl md:text-5xl font-black text-background-50 tracking-wide">
              商务合作 & 投稿
            </h2>
            <p className="mt-4 text-background-50/80 text-sm md:text-base leading-relaxed space-y-1">
              <span className="block">商务合作邮箱：hello@baoliaowang.cn</span>
              <span className="block">投稿爆料邮箱：hello@baoliaowang.cn</span>
              <span className="block">联系地址：北京市朝阳区</span>
            </p>
            <div className="mt-8 flex justify-center">
              <a
                href="mailto:hello@baoliaowang.cn"
                className="inline-flex items-center gap-3 pl-5 pr-6 py-3.5 bg-foreground-950 text-background-50 font-semibold text-sm rounded-full transition-all duration-200 hover:bg-foreground-800 whitespace-nowrap cursor-pointer group"
              >
                <span className="w-8 h-8 bg-accent-500 rounded-full flex items-center justify-center shrink-0">
                  <i className="ri-mail-line text-background-50 text-base"></i>
                </span>
                <span>立即联系</span>
                <i className="ri-arrow-right-up-line text-lg transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"></i>
              </a>
            </div>
          </div>
        </section>

        <section className="py-16 md:py-20 bg-background-50">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 text-center mb-12">
              常见问题
            </h2>
            <div className="space-y-4">
              <div className="bg-background-100 rounded-xl p-5 md:p-6">
                <h3 className="font-heading font-bold text-foreground-900 text-sm md:text-base">
                  911爆料网是什么？
                </h3>
                <p className="mt-2 text-foreground-600 text-sm leading-relaxed">
                  911爆料网是国内领先的娱乐爆料平台，专注于网红翻车、明星私料、综艺黑幕等实时追踪报道，被誉为"吃瓜黑料第一站"。
                </p>
              </div>
              <div className="bg-background-100 rounded-xl p-5 md:p-6">
                <h3 className="font-heading font-bold text-foreground-900 text-sm md:text-base">
                  如何向911爆料网投稿？
                </h3>
                <p className="mt-2 text-foreground-600 text-sm leading-relaxed">
                  您可以将爆料内容发送至投稿邮箱 hello@baoliaowang.cn，我们的编辑团队会在24小时内审核并回复。所有爆料人的信息将严格保密。
                </p>
              </div>
              <div className="bg-background-100 rounded-xl p-5 md:p-6">
                <h3 className="font-heading font-bold text-foreground-900 text-sm md:text-base">
                  911爆料网的信息来源可靠吗？
                </h3>
                <p className="mt-2 text-foreground-600 text-sm leading-relaxed">
                  911爆料网采用多方交叉验证机制，所有爆料均经过至少两个独立信源的核实才会发布。我们坚持"不传谣、不信谣"的原则，致力于为吃瓜群众提供真实可靠的娱乐资讯。
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}